import isError from "lodash/isError";
import type { AnyAction } from "redux";
import type { Epic } from "redux-observable";

import { Logger } from "~/tools/logger";
import { EMPTY, catchError, flatMap, from, of } from "~/tools/rxjs";

import { getStackPacks } from "../../../../backend/StackPacksApi";
import { ofType } from "../../../../generic/redux/TypedRedux";
import type { RootState } from "../../RootState";
import type { UsageTrack } from "../../usage-track/UsageTrackActions";

import { type SetStackPacks, type SetStackPacksError, setStackPacks, setStackPacksError } from "./StackPacksActions";
import { STACK_PACKS_FETCH } from "./StackPacksActionTypes";

type EpicResponse = UsageTrack | SetStackPacks | SetStackPacksError;

const logger = Logger.namespace("StackPacksApiEpic");

export const StackPacksApiEpic: Epic<AnyAction, EpicResponse, RootState> = (actions) =>
	actions.pipe(
		ofType(STACK_PACKS_FETCH),
		flatMap(() =>
			from(getStackPacks()).pipe(
				flatMap((stackpacks) => [setStackPacks(stackpacks)]),
				catchError((error: unknown) => {
					if (!isError(error)) {
						return EMPTY;
					}

					logger.error(error);
					return of(setStackPacksError(error));
				}),
			),
		),
	);
